export const TRANSITION_REDIRECTED = 'TransitionRedirected'

export const TRANSITION_CANCELLED = 'TransitionCancelled'
